/**
 * @generated SignedSource<<a6d49a8ce494909bd8c7994de028015b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateIntegrationDescriptionInput = {
  description?: string | null | undefined;
  integrationId: any;
};
export type PostgreSQLIntegrationsDialogUpdateDescriptionMutation$variables = {
  input: UpdateIntegrationDescriptionInput;
};
export type PostgreSQLIntegrationsDialogUpdateDescriptionMutation$data = {
  readonly updateIntegrationDescription: {
    readonly error: string | null | undefined;
    readonly integration: {
      readonly description: string | null | undefined;
      readonly id: any;
    } | null | undefined;
  };
};
export type PostgreSQLIntegrationsDialogUpdateDescriptionMutation = {
  response: PostgreSQLIntegrationsDialogUpdateDescriptionMutation$data;
  variables: PostgreSQLIntegrationsDialogUpdateDescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIntegrationDescriptionPayload",
    "kind": "LinkedField",
    "name": "updateIntegrationDescription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLIntegration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostgreSQLIntegrationsDialogUpdateDescriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostgreSQLIntegrationsDialogUpdateDescriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b7a5bf112e4e2d9327908c196e3f705e",
    "id": null,
    "metadata": {},
    "name": "PostgreSQLIntegrationsDialogUpdateDescriptionMutation",
    "operationKind": "mutation",
    "text": "mutation PostgreSQLIntegrationsDialogUpdateDescriptionMutation(\n  $input: UpdateIntegrationDescriptionInput!\n) {\n  updateIntegrationDescription(input: $input) {\n    integration {\n      id\n      description\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "644d8287bdb0f04959e58e2c51fa8991";

export default node;
